import React from 'react';

const JobCardSkeleton = () => {
  return (
    <div className="group bg-white border border-slate-100 rounded-[2rem] shadow-sm hover:shadow-xl hover:border-blue-100 transition-all duration-300 flex flex-col h-full overflow-hidden animate-pulse">
      {/* Header & Badge */}
      <div className="p-6 pb-0 flex justify-between items-start">
        <span className="h-6 w-24 bg-slate-100 rounded-full" />
        <div className="w-10 h-10 bg-slate-50 rounded-xl border border-slate-100" />
      </div>

      {/* Main Info */}
      <div className="p-6 pt-4 flex-grow space-y-4">
        <div className="h-5 w-3/4 bg-slate-100 rounded-md" />
        <div className="h-4 w-1/2 bg-slate-100 rounded-md" />

        {/* Info Grid */}
        <div className="grid grid-cols-2 gap-3 mt-4">
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-slate-100 rounded-full" />
            <div className="h-3 w-20 bg-slate-100 rounded-md" />
          </div>
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-slate-100 rounded-full" />
            <div className="h-3 w-20 bg-slate-100 rounded-md" />
          </div>
        </div>

        {/* Description area */}
        <div className="space-y-2 mt-4">
          <div className="h-3 w-full bg-slate-100 rounded-md" />
          <div className="h-3 w-5/6 bg-slate-100 rounded-md" />
          <div className="h-3 w-2/3 bg-slate-100 rounded-md" />
        </div>

        {/* Read more button placeholder */}
        <div className="mt-2 h-3 w-24 bg-slate-100 rounded-full" />
      </div>

      {/* Action Footer */}
      <div className="p-4 bg-slate-50 border-t border-slate-100">
        <div className="w-full h-11 bg-slate-900/5 rounded-2xl" />
      </div>
    </div>
  );
};

export default JobCardSkeleton;

